<template>
    <div>

        <div class="basic-info-entry prospect-detail">
            <BasicTitle title="房屋勘测详情"></BasicTitle>
            <!--      选择器      -->
            <div class="select-content">
                <div class="select-item" @click="handleRoomProspectSelect(item)" v-for="item in arrSelectProspect" :key="item.key">
                    <p v-if="!item.input" class="text">{{ item.value || item.name }}</p>
                    <input :disabled="!arrSelectProspect[0].value" v-model="item.value" @blur="reportFloorChange" v-else :placeholder="item.name">
                    <img v-if="!item.input" :src="require('@/assets/images/hvac/mapping/chevron-down.png')" class="icon" alt="">
                </div>
            </div>
            <!--      楼层信息      -->
            <div v-if="arrSelectProspect[0].value" class="floor-content">
                <!--   楼层导航    -->
                <div class="nav-floor">
                    <p @click="switchFloor(nav.name)" class="floor-item" :class="{'select-floor-item': nav.select}" v-for="nav in arrRoomAreaList">
                        <span class="name">{{ nav.name }}</span>
                    </p>
                </div>
                <!--       资源表格         -->
                <table class="floor-info">
                    <!--             表头       -->
                    <tr class="floor-tr-head">
                        <th class="floor-th" v-for="th in arrTableColumnList" :key="th.key">{{ th.name }}</th>
                    </tr>
                    <!--            数据        -->
                    <tr class="floor-tr-body" v-for="room in selectRoomArea.rooms" :key="room.name">
                        <td v-for="(tableKey,index) in arrTableColumnList">
                            <!--       第3个之后都是图标  /   1 和 2 要添加单位       -->
                            <img class="icon" :src="require('@/assets/images/hvac/mapping/table-sure.png')" v-if="index >= 4 && room[tableKey.key]" alt="">
                            <p class="text" v-if="index < 4 ">{{ room[tableKey.key] ? String(room[tableKey.key]) + ([1, 3].includes(index) ? (index === 1 ? 'm²' : 'm') : '') : '' }} </p>
                        </td>
                    </tr>
                </table>

                <!--               汇总     -->
                <div class="reduce-info">
                    <p class="reduce-item" v-for="item in arrFloorAreaList" :key="item.key"> {{ item.name }}总面积： <span class="value">{{ item.num }}m²</span></p>
                </div>
            </div>
        </div>

        <!--     房屋类型选择     -->
        <VantPopup position="bottom" round v-model="bRoomTypeSelect">
            <VantPicker @cancel="changeRoomTypeSelectVisible" @confirm="setRoomTypeValue" show-toolbar :columns="arrRoomTypeSelectList" value-key="name"></VantPicker>
        </VantPopup>

        <!--    楼层区域选择    -->
        <VantPopup position="bottom" round class="chose-content" v-model="bRoomAreaChose">
            <img @click="changeRoomAreaChoseVisible" :src="require('@/assets/images/hvac/mapping/trun-down.png')" class="hide-icon" alt="">
            <EditAddFloor @confirmEnd="changeRoomAreaChoseVisible() && $emit('confirmEnd')" @switchFloor="switchFloor" @floorEdit="changeFloorEditVisible"></EditAddFloor>
        </VantPopup>

        <!--    楼层编辑弹窗    -->
        <VantPopup v-model="bFloorEditVisible" class="edit-floor-wrap">
            <BasicTitle title="楼层编辑"></BasicTitle>
            <!--      楼层信息      -->
            <div>
                <div class="floor-leave" v-for="item in arrFloorEditAddList" :key="item.key">
                    <p v-if="item.children.length" class="name">{{ item.name }}</p>
                    <div class="leave-content">
                        <div class="leave-item" @click="changeFloorIncludes(item.key,floor.key)" :class="{'leave-item-active': floor.select }" v-for="floor in item.children" :key="floor.key">
                            {{ floor.name }}
                        </div>
                    </div>
                </div>
            </div>
            <!--      确认按钮      -->
            <div class="confirm-btn" @click="confirmEditFloor">确认</div>
        </VantPopup>

    </div>
</template>

<script>
import {Popup, Picker, Dialog} from 'vant';
import BasicTitle from './basictitle';
import EditAddFloor from './editaddfloor';
import {mapState} from "vuex";


export default {
    name: "roomProspectDetail",
    components: {
        BasicTitle,
        EditAddFloor,
        VantPopup: Popup,
        VantPicker: Picker,
    },
    data() {
        return {
            // 房屋类型选择弹窗显示控制
            bRoomTypeSelect: false,
            // 楼层区域选择弹窗显示控制
            bRoomAreaChose: false,
            // 总楼层编辑显示
            bFloorEditVisible: false,

        }
    },
    computed: {
        ...mapState({
            // 楼层数据列表
            arrRoomAreaList: state => state.hvacMappingEntry.arrRoomAreaList,
            // 表格栏数组
            arrTableColumnList: state => state.hvacMappingEntry.arrTableColumnList,
            // 楼层编辑可添加楼层数组
            arrFloorEditAddList: state => state.hvacMappingEntry.arrFloorEditAddList,
            // 房屋勘测详情渲染
            arrSelectProspect: state => state.hvacMappingEntry.arrSelectProspect,
            // 房间总面积
            arrFloorAreaList: state => state.hvacMappingEntry.arrFloorAreaList,
        }),
        // 房屋类型选择数组
        arrRoomTypeSelectList() {
            const list = this.$store.state.hvacMappingEntry.arrRoomTypeSelectList;
            const target = list.find(i => i.select);
            // 如果有选择的就设置默认显示
            if (target) {
                // 将其恢复到原状态
                this.$store.commit({
                    type: 'hvacMappingEntry/SAVE_ROOM_TYPE_SELECT_LIST', list: list.map(i => {
                        i.select = false;
                        return i;
                    })
                });
                this.setRoomTypeValue(target, false);
            }

            return list;
        },
        /**
         * 选中的楼层
         */
        selectRoomArea() {
            return this.arrRoomAreaList.find(i => i.select) ?? this.arrRoomAreaList[0] ?? {};
        },
        /**
         * 报告的基本信息配置ID
         */
        reportConfigIds() {
            return this.$store.getters['hvacMappingEntry/reportConfigIds'];
        }
    },
    methods: {
        /**
         * 报告的楼层高度变化
         */
        reportFloorChange() {
            const input = this.arrSelectProspect.find(i => i.input);
            input.value = input.value ? `${Number.parseFloat(input.value)}m` : '';
            this.$store.dispatch({type: 'hvacMappingEntry/setReportConfigInfo'});
        },
        /**
         * 楼层编辑弹窗显示控制
         */
        changeFloorEditVisible() {
            this.bFloorEditVisible = !this.bFloorEditVisible;
        },
        /**
         * 房屋类型选择弹窗显示控制
         */
        changeRoomTypeSelectVisible() {
            const {canNext} = this.reportConfigIds;

            if (canNext) {
                this.bRoomTypeSelect = !this.bRoomTypeSelect;
            } else {
                Dialog({message: '请录入基本信息'})
            }

        },
        /**
         * 房屋区域选择弹窗显示控制
         */
        changeRoomAreaChoseVisible() {

            if (!this.arrSelectProspect[0].value) {
                Dialog({message: '请选择房型'});
            } else {
                this.bRoomAreaChose = !this.bRoomAreaChose;
            }
            return true;

        },
        /**
         * 房屋类型选择确认 设置房屋类型
         * @param value
         * @param click
         */
        async setRoomTypeValue(value, click) {

            const {name} = value;

            const list = this.arrSelectProspect.map(i => {
                i.key === '1' && (i.value = name);
                return i;
            });
            this.$store.commit({type: 'hvacMappingEntry/CHANGE_SELECT_PROSPECT', list});

            // 判断是否要触发关闭视图
            if (typeof click !== 'boolean') {
                this.changeRoomTypeSelectVisible();
                // 发送配置信息
                await this.$store.dispatch({type: 'hvacMappingEntry/setReportConfigInfo',})
            }

            this.$store.commit({type: 'hvacMappingEntry/CHANGE_FLOOR_EDIT_ADD_LENGTH', info: value});

        },
        /**
         * 房屋勘察详情项点击
         * @param item
         */
        handleRoomProspectSelect(item) {
            switch (item.key) {
                // 楼层类型
                case '1':
                    this.changeRoomTypeSelectVisible();
                    break;
                // 区域配置
                case '2':
                    this.changeRoomAreaChoseVisible();
                    break;
            }
        },
        /**
         * 切换选择的楼层
         * @param floorName
         */
        switchFloor(floorName) {
            const list = this.arrRoomAreaList.map(i => {
                i.select = i.name === floorName;
                return i;
            });
            this.$store.commit({type: 'hvacMappingEntry/CHANGE_ROOM_AREA_LIST', list});
        },

        /**
         * 楼层编辑点击
         */
        changeFloorIncludes(parentKey, key) {
            const list = this.arrFloorEditAddList.map(item => {
                if (item.key === parentKey) {
                    item.children = item.children.map(i => {
                        i.key === key && (
                            i.select = !i.select
                        );

                        return i;
                    });
                }
                return item;

            });
            this.$store.commit({type: 'hvacMappingEntry/CHANGE_FLOOR_EDIT_ADD_LIST', list});
        },
        /**
         * 确认编辑楼层
         */
        async confirmEditFloor() {
            // 展开
            const includesFloor = this.arrFloorEditAddList.map(i => i.children).flat(Infinity).filter(i => i.select);

            // 先把不要的去掉
            let list = this.arrRoomAreaList.filter(floor => includesFloor.some(i => i.key === floor.key));

            // 把需要添加的加入
            includesFloor.forEach(({key, name}) => {
                const has = this.arrRoomAreaList.some(i => i.key === key);
                if (!has) {
                    list.push({name, key, rooms: []});
                }
            });
            // 排序
            list = list.map(i => {
                const floorNum = Number.parseInt(i.key);
                i.orderNum = floorNum >= 0 ? floorNum : list.length + Math.abs(floorNum);
                return i;
            }).sort((a, b) => a.orderNum - b.orderNum).map((i, index) => {
                i.select = index === 0;
                return i;
            });

            await this.$store.dispatch({type: 'hvacMappingEntry/setReportFloor', list});

            // 关闭弹窗
            this.changeFloorEditVisible();
        }
    }
}
</script>

<style scoped lang="scss">

.basic-info-entry {
    padding: 32px 24px 28px;
    border-radius: $commonRadius;
    background: #FFFFFF;
    margin-bottom: 28px;


    .select-content {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-top: 28px;

        .select-item {
            flex: 1;
            border: 1px solid #DBDBDB;
            border-radius: $commonRadius;
            padding: 0 12px 0 20px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-right: 22px;
            height: 80px;


            .text {
                line-height: 80px;
                height: 80px;
            }

            .icon {
                width: 32px;
                height: 32px;
            }


            &:nth-child(2) {
                flex: 0 0 auto;
                width: 280px;

                .icon {
                    transform: rotate(-90deg);
                }
            }


            &:last-child {
                flex: 0 0 auto;
                color: #A2A2A2;
                margin-right: 0;
                padding: 0 12px;
                width: 162px;
                //background: #F7F7F7;
                display: flex;
                justify-content: center;

                input {
                    background: #FFF;
                    width: 120px;
                    text-align: center;
                    color: $commonText;

                    &::placeholder {
                        color: #A2A2A2;
                    }

                }
            }
        }
    }

    .floor-content {
        padding-top: 32px;

        .nav-floor {
            display: flex;
            align-content: center;

            overflow-x: auto;

            .floor-item {
                white-space: nowrap;
                margin-bottom: 32px;
                margin-right: 100px;
                height: 52px;
                width: max-content;
                display: flex;
                align-items: flex-start;
                color: #A2A2A2;

                .name {
                    line-height: 40px;
                }

                &:last-of-type {
                    margin-right: 0;
                }
            }

            .select-floor-item {
                color: $deepGreen;
                font-weight: 500;
                background: linear-gradient(to right, $deepGreen, $deepGreen) no-repeat bottom center / 100% 4px;
            }
        }

        .floor-info {
            width: 100%;
            font-size: $smallSize;
            margin-bottom: 8px;

            .floor-tr-head {
                height: 50px;
                border-bottom: 2px solid #F1F1F1;
                text-align: center;

                .floor-th:first-of-type {
                    text-align: start;
                }

                .floor-th:last-of-type {
                    text-align: end;
                }
            }

            .floor-tr-body {
                height: 92px;
                background: linear-gradient(to right, #F1F1F1 50%, transparent 50%) repeat-x left bottom / 18px 2px;
                text-align: center;
                color: #A2A2A2;

                td:first-of-type {
                    text-align: start;
                    color: $deepGreen;
                }

                td:last-of-type {
                    text-align: end;
                }

                .text {
                    line-height: 90px;
                }

                .icon {
                    width: 36px;
                    height: 36px;
                }
            }
        }

        .reduce-info {
            font-size: $baseSize;
            font-weight: 500;
            color: #222222;

            .reduce-item {
                height: 40px;
                line-height: 40px;
                display: inline-block;
                width: 50%;
                margin-top: 16px;

                .value {
                    font-size: $smallSize;
                }
            }
        }
    }
}

.prospect-detail {
    margin-bottom: 24px;
}

.chose-content {
    width: 100%;
    height: 90vh;
    padding: 20px 28px 60px;

    .hide-icon {
        position: sticky;
        top: 0;
        width: 58px;
        height: 20px;
        display: block;
        margin: 0 auto 20px;
    }
}


.edit-floor-wrap {
    width: 702px;
    height: 696px;
    background: #FFFFFF;
    border-radius: $commonRadius;
    padding: 32px 24px 60px;

    .floor-leave {
        margin-top: 20px;


        .name {
            margin: 4px 0 16px;
            line-height: 40px;
        }

        .leave-content {
            display: flex;
            align-items: center;
            flex-wrap: wrap;


            .leave-item {
                width: 204px;
                height: 80px;
                background: #F7F7F7;
                color: #A2A2A2;
                line-height: 80px;
                text-align: center;
                border-radius: $commonRadius;
                margin-right: 20px;
                margin-bottom: 20px;

                &:nth-child(3n + 3) {
                    margin-right: 0;
                }
            }


            .leave-item-active {
                background: rgba($deepGreen, 0.1);
                color: $deepGreen;
                font-weight: 500;
            }
        }

        &:last-child {
            .leave-content {
                .leave-item {
                    width: 316px;

                    &:nth-child(2n + 2) {
                        margin-right: 0;
                    }
                }


            }

        }
    }

    .confirm-btn {
        width: 328px;
        height: 80px;
        background: $userBgGradient;
        border-radius: $commonRadius;
        line-height: 80px;
        text-align: center;
        color: #FFFFFF;
        margin: 40px auto 0;

    }
}
</style>